import {
  collectHubRideActionContexts,
  getHubRideActionTranslationKey,
  getHubRideActionTranslationParams,
  HubRideActionKind,
} from "@ryde/shared";

export const buildHubRideConfirmMessage = ({
  actionKind,
  hubContexts,
  t,
}: {
  actionKind: HubRideActionKind;
  hubContexts: ReturnType<typeof collectHubRideActionContexts>;
  t: (key: string, options?: Record<string, string | number>) => string;
}): string => {
  const primaryContext = hubContexts[0];
  const messageKey = getHubRideActionTranslationKey({
    actionKind,
    hubSegment: primaryContext.hubSegment,
  });
  const translationParams = getHubRideActionTranslationParams(primaryContext);

  // Primary context drives segment wording; pairedSegmentsCount covers bulk/multi-ride selection.
  return t(messageKey, {
    relatedRideIds: translationParams.relatedRideIds,
    passengersCount: translationParams.passengersCount,
    segmentLabel: t(String(translationParams.segmentLabelKey)),
    relatedSegmentLabel: t(String(translationParams.relatedSegmentLabelKey)),
    pairedSegmentsCount: hubContexts.length,
  });
};
